'use strict';

import angular from 'angular';
import {
  UtilService
} from './util.service';

export default angular.module('conduu.ap.components.util', [])
  .factory('Util', UtilService)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/util/util.module.js